import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import { Link } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import Patcss from "../../public/css/patient/style_pat.css";
import Constant from "../../constants";
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";

export default class Patientmenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Language: "",
    };
  }

  // To get detais after first render

  componentDidMount = () => {
    this.state = {
      Language: localStorage.getItem("Language_selected"),
    };
  };

  // called after the React component props or state has changed.

  componentDidUpdate = () => {
    var lang = localStorage.getItem("Language_selected");
    if (lang != null) {
      if (this.state.Language != lang) {
        this.state.Language = lang;
        this.forceUpdate();
      }
    } else {
      this.state.Language = "en-us";
    }
  };

  render() {
    return (
      <div>
        <I18nPropvider locale={this.state.Language}>
          <section id="footer">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="col2 col-md-3">
                    <h2 class="footer_head">{translate("Our Services")}</h2>
                    <p>{translate("Consult a Doctor")}</p>
                    <p>{translate("Order Medicine")}</p>
                    <p>{translate("Book for Diagnostic")}</p>
                    <p>{translate("Care at Home")}</p>
                  </div>
                  <div class="col2 col-md-3">
                    <h2 class="footer_head">{translate("Our Policies")}</h2>

                    <a
                      href={Constant.imgurl + "/patient/PrivacyPolicy"}
                      target="_blank"
                    >
                      <p>{translate("Privacy Policy")}</p>
                    </a>

                    <a
                      href={Constant.imgurl + "/patient/TermsConditions"}
                      target="_blank"
                    >
                      <p>{translate("Terms & Conditions")}</p>
                    </a>
                  </div>
                  <div class="col2 col-md-3">
                    <h2 class="footer_head">{translate("Social")}</h2>

                    <h3>{translate("Need Help")} ?</h3>
                    <p>
                      <span>
                        <i class="fa fa-phone"></i>
                      </span>
                      +91 – 9876543210
                    </p>
                    <a href="mailto:support@medleymed.com">
                      <p>
                        <span>
                          <i class="fa fa-envelope"></i>
                        </span>
                        support@medleymed.com
                      </p>
                    </a>
                  </div>
                  <div class="col2 col-md-3">
                    <h2 class="footer_head">{translate("Our App")}</h2>

                    <p>
                      {/* <a
                        href="https://play.google.com/store/apps/details?id=com.medivar.patient"
                        target="_blank"
                      > */}
                      <img src="/images/patient/img/Homepage/Footer/Groupg.svg" />
                      {/* </a> */}
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="footer_text">
                    <h5>
                      {translate("Copyright")} © 2020,{" "}
                      {translate("MedleyMed")}.{" "}
                      {translate("All rights reserved")}.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </I18nPropvider>
      </div>
    );
  }
}
